import { render, staticRenderFns } from "./sketch.vue?vue&type=template&id=e50bd340"
import script from "./sketch.vue?vue&type=script&lang=js"
export * from "./sketch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports